module.exports = __webpack_public_path__ + "static/img/serviceP4.bafbc9e0.png";